import { render, staticRenderFns } from "./LinkedArchives.vue?vue&type=template&id=7342c7f9&scoped=true&"
import script from "./LinkedArchives.vue?vue&type=script&lang=js&"
export * from "./LinkedArchives.vue?vue&type=script&lang=js&"
import style0 from "./LinkedArchives.vue?vue&type=style&index=0&id=7342c7f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7342c7f9",
  null
  
)

export default component.exports